
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-syntax.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-streaming-syntax-demo-format"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-syntax.zh-CN.md?type=demo')
};